import { forwardRef } from 'react';
import { Progress as AntdProgress } from 'antd';

/** @param {Object} props - Same shape as antd's own `Progress`, forwarded as-is. */
const Progress = forwardRef((props, ref) => <AntdProgress ref={ref} {...props} />);
Progress.displayName = 'Progress';

export default Progress;
